import { observer } from 'mobx-react';
import React from 'react';
import itemsStore from '../../store/itemsStore';
import Switcher from 'src/view/components/Controls/Switcher/Switcer';
import Text, { TEXT } from 'src/view/components/Text/Text';
import { TOOLTIP_DURATION, TOOLTIP_POSITION } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';

const ItemOnlyForCombo: React.FC = observer((): JSX.Element | null => {
  if (!itemsStore.item) return null;

  return (
    <div className="d-flex flex-column">
      <Text type={TEXT.SECTION_HEADER} text="combo_configuration" className="mt-6" />
      <div className="d-flex flex-row align-items-center mr-8 mt-4">
        {/* switchers */}
        <Switcher status={itemsStore.item?.only_for_combo || 0} onChange={(only_for_combo) => itemsStore.changeItemHandler({ only_for_combo })} />
        <Text
          type={TEXT.SWITCHER_LABEL}
          text="only_for_combo"
          tooltip={{
            message: 'only_for_combo_toggle_infotip',
            position: TOOLTIP_POSITION.FIXED,
            duration: TOOLTIP_DURATION.LARGE,
            maxWidth: 295,
            iconSize: 16,
          }}
        />
      </div>
    </div>
  );
});

export default ItemOnlyForCombo;
